import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Box, Card, Text, Icon, Grid, Dropdown, Button } from "~/components-shared";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import StyledIcon from "~/components/StyledIcon";
import AchievementItemCard from "~/components/insightsWidgets/AchievementItemCard";
import { InsightsLineItemItemStatusEnum, InsightsLineItemItemTypeEnum, RoutesEnum } from "~/types/enums";
import { useSelector } from "react-redux";
import topicSelectors from "~/store/topics/selectors";
const StyledBox = styled(Box)`
  overflow: auto;
  height: 100%;
  position: relative;
  width: calc(100% + ${_ref => {
  let {
    theme
  } = _ref;
  return 10 / (theme.typography.fontSize / theme.spacing.step);
}}rem);

  &::-webkit-scrollbar {
    margin-left: 200px;
    width: 4px;
    height: 8px;
    background: transparent;
  }
  &::-webkit-scrollbar-track {
    background-color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.grey.main;
}};
    margin-left: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return 5 / (theme.typography.fontSize / theme.spacing.step);
}}rem;
    margin-right: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return 5 / (theme.typography.fontSize / theme.spacing.step);
}}rem;
  }
`;
const BoxWrapper = styled.div`
  position: relative;
  flex-grow: 1;
  width: 100%;

  &:after {
    content: "";
    position: absolute;
    z-index: 1;
    width: 20px;
    height: calc(100% - 10px);
    top: 0;
    right: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return -5 / (theme.typography.fontSize / theme.spacing.step);
}}rem;
    background: ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.colors.gradients.secondaryBackground(90);
}};
  }
`;
const AchievementsCard = _ref7 => {
  let {
    widget,
    dateFrom,
    dateTo,
    isEditable = false,
    ...rest
  } = _ref7;
  const {
    t
  } = useTranslation();
  const [showDismissed, setShowDismissed] = React.useState(false);
  const {
    items
  } = widget.data;
  const filteredItems = items.filter(item => showDismissed || !item.isDismissed);
  const followedTopics = useSelector(topicSelectors.getFollowedTopics);
  const handleViewAll = () => {
    const params = new URLSearchParams();
    params.append("filter[types][]", InsightsLineItemItemTypeEnum.TODO);
    params.append("filter[types][]", InsightsLineItemItemTypeEnum.ACHIEVEMENT);
    params.append("filter[statuses][]", InsightsLineItemItemStatusEnum.CLOSED);
    params.append("filter[dateFrom]", dateFrom);
    params.append("filter[dateTo]", dateTo);
    followedTopics.forEach(topic => {
      params.append("filter[topicIds][]", topic.id.toString());
    });
    const url = `${window.location.origin}${RoutesEnum.PROGRESS_UPDATES}?${params.toString()}`;
    window.open(url, "_self");
  };
  return /*#__PURE__*/React.createElement(Card, _extends({
    align: "left"
  }, rest), /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    gap: 3,
    template: "1fr auto auto",
    align: "center",
    fullWidth: true,
    s: {
      mb: 5
    }
  }, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    fontSize: 8
  }, t("AchievementsCard.progressHighlights")), isEditable && /*#__PURE__*/React.createElement(Dropdown, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("common.actions.options"),
    display: "inline-block",
    direction: "bottomLeft",
    handlerProps: {
      color: showDismissed ? "translucentPrimary" : "translucent",
      s: {
        p: 2
      }
    },
    handler: /*#__PURE__*/React.createElement(Icon, {
      scale: 5,
      display: "block",
      src: "filter"
    })
  }, _ref8 => {
    let {
      isOpen,
      onItemClick
    } = _ref8;
    return /*#__PURE__*/React.createElement(Dropdown.List, {
      isOpen: isOpen
    }, /*#__PURE__*/React.createElement(Dropdown.ListItem, {
      onClick: () => {
        onItemClick();
        setShowDismissed(prev => !prev);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: showDismissed ? "checkboxFill" : "checkbox",
      s: {
        mr: 2
      },
      color: "primary"
    }), "Show Dismissed"));
  }), /*#__PURE__*/React.createElement(Button, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("AchievementsCard.viewAllHighlights"),
    onClick: handleViewAll,
    color: "translucent",
    s: {
      pl: 6,
      pr: 4,
      py: 2
    },
    fontSize: 3.5,
    elemAfter: /*#__PURE__*/React.createElement(Icon, {
      src: "arrow",
      s: {
        mt: -0.3,
        ml: 1
      }
    })
  }, t("common.actions.viewAll"))), filteredItems.length ? /*#__PURE__*/React.createElement(BoxWrapper, null, /*#__PURE__*/React.createElement(StyledBox, {
    wrap: "nowrap",
    align: "stretch",
    gap: 5,
    s: {
      px: 5,
      pb: 5,
      mx: -5
    }
  }, filteredItems.map(item => /*#__PURE__*/React.createElement(AchievementItemCard, {
    showDismissed: showDismissed,
    item: item,
    width: "342px",
    key: item.id,
    color: "background",
    isEditable: isEditable,
    align: "left",
    shadow: true
  })))) : /*#__PURE__*/React.createElement(Box, {
    direction: "column",
    justify: "center",
    align: "center",
    fullHeight: true,
    fullWidth: true
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    src: "discovery",
    color: "translucentInfo"
  }), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    weight: "semiBold",
    display: "block",
    s: {
      mt: 6
    },
    align: "center",
    style: {
      maxWidth: "300px"
    }
  }, "No Significant Achievements")));
};
export default AchievementsCard;